import { Module } from 'vuex';
import * as firebase from 'firebase/app';
import 'firebase/firestore';
import { serializer } from '../../api/shared/serializer';

const businessRulesModule: Module<any, any> = {
  namespaced: false,
  state: {
    rules: [],
    rule: null,
  },

  mutations: {
    setRules(state: any, payload: []) {
      state.rules = payload;
    },

    setRule(state: any, payload: null) {
      state.rule = payload;
    }
  },

  actions: {

    async getRules({ commit }) {
      const items = await firebase
        .firestore()
        .collection('businessRules')
        .where('facilityId', '==', this.state.authModule.currentFacility).get()
        .then((querySnapshot: any) => {
          const items = serializer.querySnapshotToDocuments<any>(querySnapshot)
          commit('setRules', items);
        });
    },

    async getRuleById({ commit }, id) {

      const item = firebase
        .firestore()
        .collection('businessRules')
        .doc(id);

      await item.get().then(querySnapshot => {
        const rule = serializer.documentSnapshotToDocument<any>(querySnapshot)
        commit('setRule', rule);
      });
    },

    async addRule({ commit }, rule: any) {
      if (!rule) return;

      rule.isActive = true
      rule.createdByStaffId = this.state.authModule.user.id
      rule.createdByStaffName = this.state.authModule.user.name

      if (!rule.facilityId) {
        rule.facilityId = this.state.authModule.currentFacility
      }

      const ruleObject = JSON.parse(JSON.stringify(rule))
      ruleObject.createdDateTime = firebase.firestore.Timestamp.fromDate(new Date())

      return await firebase.firestore().collection('businessRules').add(ruleObject)
    },

    async updateRule({ commit }, rule: any) {
      if (!rule) return;

      rule.dateTimeUpdated = firebase.firestore.Timestamp.fromDate(new Date())

      return await firebase.firestore().collection('businessRules').doc(rule.id).update({
        trigger: rule.trigger,
        actions: rule.actions,
        sendPeriod: rule.sendPeriod,
        name: rule.name
      })
    },

    async deleteRule({ commit }, ruleId: string) {

      if (!ruleId) return

      return await firebase.firestore().collection("businessRules").doc(ruleId).delete().then(() => {
        commit('setRule', null);
        console.log('rule deleted')
      })

    },

  }
};
export default businessRulesModule;
